import React from 'react';

import Searcher from 'components/DesignSystem/Searcher';
import Snackbar from 'components/DesignSystem/Snackbar';
import Section from 'components/Meteorology/Shared/ControlPanelSheet/Section';
import OptionRow from 'components/Meteorology/Shared/ControlPanelSheet/OptionRow';
import searchPattern from 'components/Meteorology/Shared/ControlPanelSheet/DetailedView/searchPattern';
import {
  NamedItem, SearchState, SectionState,
} from 'components/Meteorology/Shared/ControlPanelSheet/DetailedView/types';

import './index.scss';

export default function MultiLocationSection({
  groupedLocations, search, onSearchChange, open, onToggle,
}: SectionState & SearchState & {
  groupedLocations: {
    selectedMultiLocations: unknown[];
    groupedMultiLocations: Record<string, NamedItem[]>;
    groupIdToName: Record<string, string>;
    isLocationSelected: (id: number) => boolean;
    toggleMultiLocation: (id: number) => unknown;
  };
}) {
  const pattern = searchPattern(search);

  return (
    <Section
      label="Locais"
      valueText={groupedLocations.selectedMultiLocations.length
        ? `${groupedLocations.selectedMultiLocations.length} selecionados` : undefined}
      open={open}
      onToggle={onToggle}
    >
      <Searcher value={search} onChange={(e) => onSearchChange(e.target.value)} />
      {Object.keys(groupedLocations.groupedMultiLocations).length === 0 && (
        <Snackbar className="mt-2">Nenhum grupo selecionado</Snackbar>
      )}
      {Object.entries(groupedLocations.groupedMultiLocations)
        .map(([groupId, locations]) => (
          <div key={groupId} className="control-panel-sheet-dv-group-block">
            <span className="control-panel-sheet-dv-group-block-title">
              {groupedLocations.groupIdToName[groupId]}
            </span>
            {locations.filter((l) => pattern.test(l.name)).map((l) => (
              <OptionRow
                key={l.id}
                label={l.name}
                selected={groupedLocations.isLocationSelected(l.id)}
                onSelect={() => groupedLocations.toggleMultiLocation(l.id)}
                selectionType="multiple"
              />
            ))}
          </div>
        ))}
    </Section>
  );
}
